module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网APP管理")]), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "handle-area"
  }, [_c('div', {
    staticClass: "handle-button"
  }, [(!_vm.editable) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openDrag
    }
  }, [_vm._v("拖拽排序")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.completeDrag
    }
  }, [_vm._v("完成排序")]), _vm._v(" "), (_vm.editable) ? _c('Button', {
    on: {
      "click": _vm.orderList
    }
  }, [_vm._v("重置排序")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-area"
  }, [_c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网一级展示区产品内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.createApp(1, _vm.productInfoArea1.length)
      }
    },
    slot: "extra"
  }, [_vm._v("添加应用")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.productInfoArea1),
      callback: function($$v) {
        _vm.productInfoArea1 = $$v
      },
      expression: "productInfoArea1"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.productInfoArea1), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.appLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.productTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("应用版本: " + _vm._s(item.appVersion))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("上架时间: " + _vm._s(_vm.transDate(item.createDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("下载量: " + _vm._s(item.downloadCount))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showAppDetail(item.areaId, index)
        }
      }
    }, [_vm._v("应用详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateApp(item.areaId, index)
        }
      }
    }, [_vm._v("更新版本")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.appDown(item.areaId, index)
        }
      }
    }, [_vm._v("下架应用")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.appUp(item.areaId, index)
        }
      }
    }, [_vm._v("上架应用")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteApp(item.areaId, index)
        }
      }
    }, [_vm._v("删除应用")])], 1)])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网二级展示区产品内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.createApp(2, _vm.productInfoArea2.length)
      }
    },
    slot: "extra"
  }, [_vm._v("添加应用")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.productInfoArea2),
      callback: function($$v) {
        _vm.productInfoArea2 = $$v
      },
      expression: "productInfoArea2"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.productInfoArea2), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.appLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.productTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("应用版本: " + _vm._s(item.appVersion))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("上架时间: " + _vm._s(_vm.transDate(item.createDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("下载量: " + _vm._s(item.downloadCount))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showAppDetail(item.areaId, index)
        }
      }
    }, [_vm._v("应用详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateApp(item.areaId, index)
        }
      }
    }, [_vm._v("更新版本")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.appDown(item.areaId, index)
        }
      }
    }, [_vm._v("下架应用")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.appUp(item.areaId, index)
        }
      }
    }, [_vm._v("上架应用")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteApp(item.areaId, index)
        }
      }
    }, [_vm._v("删除应用")])], 1)])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网三级展示区产品内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.createApp(3, _vm.productInfoArea3.length)
      }
    },
    slot: "extra"
  }, [_vm._v("添加应用")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.productInfoArea3),
      callback: function($$v) {
        _vm.productInfoArea3 = $$v
      },
      expression: "productInfoArea3"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.productInfoArea3), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.appLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.productTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("应用版本: " + _vm._s(item.appVersion))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("上架时间: " + _vm._s(_vm.transDate(item.createDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("下载量: " + _vm._s(item.downloadCount))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showAppDetail(item.areaId, index)
        }
      }
    }, [_vm._v("应用详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateApp(item.areaId, index)
        }
      }
    }, [_vm._v("更新版本")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.appDown(item.areaId, index)
        }
      }
    }, [_vm._v("下架应用")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.appUp(item.areaId, index)
        }
      }
    }, [_vm._v("上架应用")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteApp(item.areaId, index)
        }
      }
    }, [_vm._v("删除应用")])], 1)])], 1)
  }), 0)], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce7a320","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/app-blocks/webAPP.vue
// module id = nE5R
// module chunks = 0